import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { Modal, Button as RsuiteBtn } from "rsuite";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";
import { AuthContext } from "../../contexts/AuthContext";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  top: 0px;
  .title {
    font-size: 20px;
    color: #252525;
    margin-bottom: 0.5rem;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 110px;
  }
  @media (max-width: 1200px) {
    top: 50px;
    background-color: #fff;
    z-index: 8;
  }
`;

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function AccountEditTitle({ Mode, rowId, sendAccountData }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  const [saveOpen, setSaveOpen] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [myself, setMySelf] = useState(false);
  const [isAdmin, setIsAdmin] = useState(null);
  const [AccountPermission, setAccountPermission] = useState(null);

  //建立時間
  const [CreateDateTime, setCreateDateTime] = useState("");
  //修改人
  const [ModifyUser, setModifyUser] = useState("");
  //修改時間
  const [ModifyDateTime, setModifyDateTime] = useState("");
  //Line綁定
  const [LineBinding, setLineBinding] = useState("");

  const handleSaveOpen = () => setSaveOpen(true);
  const handleSaveClose = () => setSaveOpen(false);

  const handleCancelOpen = () => setCancelOpen(true);
  const handleCancelClose = () => setCancelOpen(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);

    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);

    setIsAdmin(myAuth.IsAdmin);
    setAccountPermission(myAuth.AccountPermission);
  }, []);

  const sendFormData = async ({ sendAccountData }) => {
    const data = {
      Data: sendAccountData,
    };

    if (AccountId === sendAccountData.RowId) {
      setMySelf(true);
    } else {
      setMySelf(false);
    }
    if (sendAccountData.hasPhoneNumberError) {
      alert("手機號碼格式錯誤");
      return;
    }
    if (sendAccountData.CanSNS && sendAccountData.PhoneNumber === "") {
      alert("「可發送簡訊」請提供手機號碼");
      return;
    }
    const result = await apiClient.postAes("api/account/Update/Security", data);
    if (result?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
    }

    if (+result?.data?.Code !== 0 || result?.status !== 200) {
      alert("帳號存檔失敗");
    }

    return result;
  };

  useEffect(() => {
    setCreateDateTime(sendAccountData?.CreateDateTime);
    setModifyUser(sendAccountData?.ModifyUser);
    setModifyDateTime(sendAccountData?.ModifyDateTime);
    setLineBinding(sendAccountData?.LineBinding);
  }, [sendAccountData]);

  const { data, mutate, isSuccess, isLoading } = useMutation(sendFormData, {
    onSuccess: (data) => {
      const { Code, Message } = data?.data;
      if (+Code === 1) {
        alert(Message);
      }
      if (+Code === 0) {
        if (AccountId === sendAccountData.RowId) {
          setSaveOpen(true);
        } else {
          alert("修改成功");
          navigate("/AccountManageList");
        }
      }
    },
  });

  const { data: FormResData } = data || {};
  // useEffect(() => {
  //   const code = +FormResData?.Code;
  //   if (isSuccess && code === 0) {
  //     if (myself) {
  //     } else {
  //       alert("修改成功");
  //       navigate("/AccountManageList");
  //     }
  //   }
  // }, [FormResData]);

  const NoAdminHandler = () => {
    navigate("/ReferralDataList");
  };

  return (
    <Container>
      <ul>
        <li>
          <div className="title">編輯帳號</div>
        </li>
        <li>
          <div>建檔時間：{CreateDateTime}</div>
        </li>
        <li>
          <div>
            最近操作：{ModifyUser}
            {ModifyDateTime}
          </div>
        </li>
        <li>
          <div>Line綁定：{LineBinding}</div>
        </li>
      </ul>
      <div className="btn">
        <div>
          <CssCancelButton
            size="small"
            variant="outlined"
            style={{ minWidth: "50px" }}
            onClick={
              AccountPermission == 1 || AccountPermission == 2
                ? handleCancelOpen
                : NoAdminHandler
            }
          >
            取消
          </CssCancelButton>
        </div>
        {AccountPermission == 1 || AccountPermission == 2 ? (
          <div>
            <CssSaveButton
              size="small"
              variant="contained"
              style={{ minWidth: "50px" }}
              onClick={() => {
                mutate({ sendAccountData });
              }}
            >
              存檔
            </CssSaveButton>
          </div>
        ) : (
          ""
        )}
      </div>
      <Modal open={saveOpen} onClose={handleSaveClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>
            修改資料後，需重新登入資料才會生效，是否要重新登入？
          </div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            style={{
              backgroundColor: "#3498ff",
              color: "#ffffff",
            }}
            onClick={() => {
              navigate("/Login");
            }}
            appearance="primary"
          >
            是
          </RsuiteBtn>
          <RsuiteBtn
            onClick={() => {
              navigate("/AccountManageList");
            }}
          >
            否
          </RsuiteBtn>
        </Modal.Footer>
      </Modal>

      <Modal open={cancelOpen} onClose={handleCancelClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "18px" }}>若有資料未儲存</div>
          <div style={{ fontSize: "14px" }}>「確認」取消將不保留您的資料</div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            style={{
              backgroundColor: "#3498ff",
              color: "#ffffff",
            }}
            onClick={() => {
              isAdmin == true
                ? navigate("/AccountManageList")
                : navigate("/ReferralDataList");
            }}
          >
            確認
          </RsuiteBtn>
          <RsuiteBtn onClick={handleCancelClose}>取消返回</RsuiteBtn>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default AccountEditTitle;
